import create from 'zustand'

interface HiddenPlanLabelsState {
  hiddenIdGroups: Record<string, string[]>
  addHiddenIdGroup: (idGroup: string, ids: string[]) => void
  removeHiddenIdGroup: (idGroup: string) => void
}

/**
 * Plan label guids hidden from the batched floorplan render, grouped by an
 * arbitrary id so independent hiders don't clobber each other — same shape as
 * `useHideElements` / `useHideFloorplanElements`, but scoped to labels only
 * (the element itself stays visible). Written by `useHideLabels`, read by
 * `FloorplanModelLabels`.
 */
const useHiddenPlanLabelsStore = create<HiddenPlanLabelsState>(set => ({
  hiddenIdGroups: {},
  addHiddenIdGroup: (idGroup, ids) =>
    set(state => ({ hiddenIdGroups: { ...state.hiddenIdGroups, [idGroup]: ids } })),
  removeHiddenIdGroup: idGroup =>
    set(state => {
      const next = { ...state.hiddenIdGroups }
      delete next[idGroup]
      return { hiddenIdGroups: next }
    }),
}))

export default useHiddenPlanLabelsStore
